import React from 'react';
import { SearchMd } from '../../icons/SearchMd';

const NoDataFoundSmall = ({ message = "No data found", subMessage = "Try adjusting your filters or search terms",addCss="" }) => {
  return (
    <div className={`no-data-container flex flex-col items-center justify-center w-full py-4 px-4`}>
      <div className="bg-[#f6f6f6] rounded-full p-6 mb-4">
        <SearchMd className="w-12 h-12 text-gray-400" />
      </div>
      
      <h3 className="text-lg font-semibold font-secondary text-black mb-2">
        {message}
      </h3>
      
      <p className="text-sm text-[#666666] font-secondary text-center">
        {subMessage}
      </p>
    </div>
  );
};

export default NoDataFoundSmall;